import { IPageTabNavLink } from "../interfaces-and-types";

export const brandingLink: IPageTabNavLink[] = [
    {
        name: 'Branding',
        route: '',
    },
]